import React from "react";
import "../styles/BookingProcess.css";

import { FaCalendarCheck } from "react-icons/fa";
import { FaCheckDouble, FaWandMagicSparkles } from "react-icons/fa6";
import { HiArrowNarrowRight } from "react-icons/hi";
import { useRef } from "react";
import { useEffect } from "react";

const steps = [
  {
    icon: <FaCalendarCheck />,
    title: "Book Appointment",
    text: "Tell us what type of service you need, your preferred date, and the time that works best for you.",
  },
  {
    icon: <FaCheckDouble />,
    title: "Choose Package",
    text: "We’ll provide a price and time estimate, then help you choose the best option for your needs.",
  },
  {
    icon: <FaWandMagicSparkles />,
    title: "We Serve, You Relax",
    text: "Our professional team arrives on time and delivers the service as agreed.",
  },
];

const BookingProcess = () => {

    const servicesRef = useRef(null);
            
useEffect(() => {
  const revealElements =
    servicesRef.current?.querySelectorAll("[data-reveal]") || [];

  const scrollReveal = () => {
    revealElements.forEach((el) => {
      const elementIsInScreen =
        el.getBoundingClientRect().top < window.innerHeight / 1.15;

      if (elementIsInScreen) {
        el.classList.add("revealed");
      } else {
        el.classList.remove("revealed");
      }
    });
  };

  window.addEventListener("scroll", scrollReveal);
  scrollReveal(); // run on load

  return () => {
    window.removeEventListener("scroll", scrollReveal);
  };
}, []);


  return (
    <section className="booking-process" ref={servicesRef}>
      <div className="booking-header">
        <span data-reveal>Book in 60 seconds</span>
        <h2 data-reveal>Quick & Easy Booking Process</h2>
      </div>

      <div className="booking-steps">
        {steps.map((step, index) => (
          <div className="booking-step" key={index}>
            <div className="step-icon" data-reveal>{step.icon}</div>

            <h3 data-reveal>{step.title}</h3>
            <p data-reveal>{step.text}</p>

            {index < steps.length - 1 && (
              <div className={`curve-arrow arrow-${index + 1}`} >
                <HiArrowNarrowRight />
              </div>
            )}
          </div>
        ))}
      </div>

      <a href="/services" className="booking-btn" data-reveal>
        Get Started
      </a>
    </section>
  );
};

export default BookingProcess;